/**
 * @Author: Zewei
 * @Date:   2018-01-24T13:22:47+08:00
 * @Last modified by:
 * @Last modified time: 2018-02-07T17:49:04+08:00
 */

 import React, { Component } from 'react';
 import { Modal, Button, Row, Col, Select, Input, Table, Spin, Checkbox } from 'antd';
 import './roleManagementModal.less';

 const Option = Select.Option;
 const modalTableColumns = [{
   title: '主模块',
   dataIndex: 'name',
   key: 'main'
 }];
 const paginationCfg = {
   pageSize: 6
 };
let requiredPermissions = [];

 class RoleEditModal extends Component {

     render() {
         const { initRole, roleDetail, modalVisible,
                 onCheckboxChange, onCancel, handleEditRole, handleInputChange, handleSelectChange } = this.props;

         let initPermissions = roleDetail.permissions; // 编辑当前角色 初始时 的 权限 列表

         requiredPermissions = initPermissions.map((item) => {
             let requiredPermissionItem = {};
             requiredPermissionItem['module_id'] = item['module_id'];
             requiredPermissionItem['module_name'] = item['module_name'];
             requiredPermissionItem['c_value'] = item['c_value'];
             requiredPermissionItem['u_value'] = item['u_value'];
             requiredPermissionItem['r_value'] = item['r_value'];
             requiredPermissionItem['d_value'] = item['d_value'];
             return requiredPermissionItem;
         })

         console.log('child component requiredPermissions', requiredPermissions)

         let modalTitle = '编辑角色',
             ModalFooterBtn = [
                 <Button key="back" onClick={onCancel}>关闭</Button>,
                 <Button key="submit" type="primary" onClick={handleEditRole.bind(this, requiredPermissions)}>提交</Button>,
             ];

         let innerColumns = [
                 { title: '子项', dataIndex: 'name', key: 'name' },
                 { title: '创建', key: 'c_value',
                     render: (record) =>
                     <div>
                         <label className="innerLabel">创建</label>
                         <Checkbox
                             defaultChecked={roleDetail.permissions.some((item) => {
                                 return item['module_id'] === record.id && item['c_value']
                             })}
                             onChange={onCheckboxChange.bind(this, record, 'c_value')}
                         />
                     </div>
                 },
                 { title: '修改', key: 'u_value',
                     render: (record) =>
                     <div>
                         <label className="innerLabel">修改</label>
                         <Checkbox
                             defaultChecked={roleDetail.permissions.some((item) => {
                                 return item['module_id'] === record.id && item['u_value']
                             })}
                             onChange={onCheckboxChange.bind(this, record, 'u_value')}
                         />
                     </div>
                 },
                 { title: '查询', key: 'r_value',
                     render: (record) =>
                     <div>
                         <label className="innerLabel">查询</label>
                         <Checkbox
                             defaultChecked={roleDetail.permissions.some((item) => {
                                 return item['module_id'] === record.id && item['r_value']
                             })}
                             onChange={onCheckboxChange.bind(this, record, 'r_value')}
                         />
                    </div>
                 },
                 { title: '删除', key: 'd_value',
                     render: (record) =>
                     <div>
                         <label className="innerLabel">删除</label>
                         <Checkbox
                             defaultChecked={roleDetail.permissions.some((item) => {
                                 return item['module_id'] === record.id && item['d_value']
                             })}
                             onChange={onCheckboxChange.bind(this, record, 'd_value')}
                         />
                     </div>
                 },
             ];

         return (
             <Modal
               title={modalTitle}
               visible={modalVisible}
               onCancel={onCancel}
               width={1000}
               footer={ModalFooterBtn}
               destroyOnClose={true}
             >
                 {
                   initRole ?
                     <div>
                       <Row gutter={16}>
                           <Col span={12}>
                             <label>角色名称</label>
                             <Input
                                 className="fixedModalInput"
                                 onChange={handleInputChange.bind(this, 'name')}
                                 defaultValue={roleDetail ? roleDetail.name : ''}
                             />
                           </Col>
                           <Col span={12}>
                             <label>部门</label>
                             <Select
                                 className="fixedModalInput"
                                 onChange={handleSelectChange.bind(this, 'department')}
                                 defaultValue={roleDetail ? roleDetail.department : '选择部门'}
                             >
                               {
                                 initRole.Departments.map((item) => (
                                   <Option key={item.Value}>{ item.Text }</Option>
                                 ))
                               }
                             </Select>
                           </Col>
                         </Row>
                         <Row gutter={16} style={{marginTop: 20, marginBottom: 10}}>
                           <Col span={12}>
                             <label>角色等级</label>
                             <Select
                                 className="fixedModalInput"
                                 onChange={handleSelectChange.bind(this, 'level')}
                                 defaultValue={roleDetail ? roleDetail.level : "选择角色等级"}
                             >
                                 {
                                   initRole.Levels.map((item) => (
                                     <Option key={item.Value}>{ item.Text }</Option>
                                   ))
                                 }
                             </Select>
                           </Col>
                           <Col span={12}>
                             <label>职能</label>
                             <Select
                                 className="fixedModalInput"
                                 onChange={handleSelectChange.bind(this, 'competency')}
                                 defaultValue={roleDetail ? roleDetail.competency :"选择职能"}
                             >
                                 {
                                   initRole.Functions.map((item) => (
                                     <Option key={item.Value}>{ item.Text }</Option>
                                   ))
                                 }
                             </Select>
                           </Col>
                         </Row>
                         <Table
                           columns={modalTableColumns}
                           dataSource={initRole.Modules}
                           scroll={{ y: 300 }}
                           pagination={paginationCfg}
                           rowKey={record => record.id}
                           expandedRowRender={
                             (record) => {
                               return (
                                 <Table
                                   className="innerEditRoleTable"
                                   columns={innerColumns}
                                   dataSource={record.Children}
                                   pagination={false}
                                   rowKey={record => record.id}
                                   scroll={{ x: 1000 }}
                                 />
                               );
                             }
                           }
                         />
                     </div>
                     :
                     <Spin />
                 }
             </Modal>
         )
     }
 }

 export default RoleEditModal;



// WEBPACK FOOTER //
// ./src/components/SystemSetting/RoleEditModal.js